import ClientLogo from './client-logo';

export default ClientLogo;
